
<template>
            <div class="modal">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="Dismiss()">&times;</button>
                            <h4 class="modal-title"><i class="fa fa-exclamation-triangle text-danger"/>          Error</h4>
                        </div>
                        <div class="modal-body">
                            <p>{{message}}</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default" data-dismiss="modal"  @click="Dismiss()">Close</button>
                        </div>
                    </div>
                </div>
            </div>

</template>
<script>
    import $ from 'jquery';

    export default {
        props: ['value', 'message'],
        watch : {
            value: function () {
                console.log("Show modal ", this.value)

                var $modal = $(this.$el);

                if (this.showModal) {
                    $modal.modal('show')
                }
                else {
                    $modal.modal('toggle')
                }
            }
        },
        methods: {
            Dismiss: function () {
                this.$emit('input', false);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// servererrorhandler.scp.html?01c71938